<template>
  <b-list-group class="mt-3">
    <b-list-group-item
      v-for="calendar in calendars"
      :key="calendar.id"
      :style="{ 'color': calendar.bgColor }"
    >
      {{ calendar.name }}
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import { BListGroup, BListGroupItem } from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CalendarCalendarsList',
  components: {
    BListGroup,
    BListGroupItem
  },
  computed: {
    ...mapGetters('calendar', [
      'getCalendars'
    ]),
    calendars () {
      return this.getCalendars
    }
  }
}
</script>

<style scoped>

</style>
